module.exports = __webpack_public_path__ + "media/components/Shared/Slick/prevArrow-4136b0f17dd564bd87203e25bfd6d36e.svg";